import React from 'react';
import './ShopCollections.css';
import img1 from '../../assets/images/creations/apparel/top_1.png';
import img2 from '../../assets/images/creations/table_cloth/tc_3.png';
import img3 from '../../assets/images/creations/apparel/top_2.png';

const collections = [
  { id: 1, src: img1, alt: 'Handbag' },
  { id: 2, src: img2, alt: 'Plushie' },
  { id: 3, src: img3, alt: 'Doilies' },
];

function ShopCollections(): React.ReactElement {
  return (
    <section className="shop-collections" id="collections">
      <div className="shop-collections-inner">
        <h2>Shop Our Collections</h2>
        <p className="shop-collections-intro">
          Discover our carefully curated collections, each piece lovingly made with attention to detail.
        </p>
        <div className="shop-collections-grid">
          {collections.map((item) => (
            <div key={item.id} className="shop-collections-item">
              <img src={item.src} alt={item.alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ShopCollections;
